export type MailTextVariableConfig = {
    sort: number;
    name: string;
};

export type MailTextGroupConfig = {
    sort: number;
    name: string;
    description: string;
    image?: string;
    variables: Record<string, MailTextVariableConfig>;
};

export type MailTextConfigMap = Record<string, MailTextGroupConfig>;

export const mailTextConfig: MailTextConfigMap = {
    Order: {
        sort: 1,
        name: 'E-Mail-Vorlage: Bestelleingang',
        description:
            'Diese E-Mail wird bei jeder Bestellung als Zusammenfassung der gesamten Bestellung übermittelt. Darauf folgt immer eine 2. E-Mail pro Ticket mit der Bestätigung – je nach gewählter Buchungsoption.\n' +
            'Dies ist noch KEINE Bestätigung der Buchung.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO1: { sort: 2, name: 'Text 2a – Einleitung:' },
            INTRO2: { sort: 3, name: 'Text 2b – Einleitung:' },
            INFO_TICKET: {
                sort: 4,
                name: 'Text 3 – Info Bestätigung:',
            },
            INFO_KEYCARD: { sort: 5, name: 'Text 4 – Info Keycard:' },
            OUTRO: { sort: 6, name: 'Text 5 – Abschluss:' },
        },
    },

    TicketKeycard: {
        sort: 2,
        name: 'E-Mail-Vorlage: Bestätigung Keycard-Buchung',
        description:
            'Wird bei Ticketbuchung auf eine Keycard als Bestätigung versandt.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            HINT: { sort: 3, name: 'Text 4 – Info zur Nutzung:' },
            WARNING: { sort: 4, name: 'Text 5 – Info Nachweis:' },
            OUTRO: { sort: 5, name: 'Text 5 – Abschluss:' },
        },
    },

    TicketPickup: {
        sort: 3,
        name: 'E-Mail-Vorlage: Bestätigung Pick-up-Voucher',
        description:
            'Wird bei Ticketbuchung mit der Option „Pick-up-Voucher“ als Bestätigung versandt. Der Voucher muss vor Ort gegen ein gültiges Zutrittsticket getauscht werden.\n' +
            'Unser Tipp: Im Text die Info platzieren, wo der Gast seinen Voucher gegen ein Ticket eintauschen kann. (z.B. pick-up-Automat bei der Talstation XY…)',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            RECOMMENDATION: {
                sort: 3,
                name: 'Text 3 – Info Ticket-Ausdruck:',
            },
            HINT: { sort: 4, name: 'Text 4 – Info zur Nutzung:' },
            WARNING: { sort: 5, name: 'Text 4 – Info Nachweis:' },
            OUTRO: { sort: 5, name: 'Text 5 – Abschluss:' },
        },
    },

    TicketBarcode: {
        sort: 4,
        name: 'E-Mail-Vorlage: Bestätigung e-Ticket',
        description:
            'Wird bei Ticketbuchung mit der Option „e-Ticket“ als Bestätigung versandt. Das Ticket wird zum direkten Zutritt beim Lift genutzt.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            HINT: { sort: 3, name: 'Text 4 – Info zur Nutzung:' },
            RECOMMENDATION: {
                sort: 4,
                name: 'Text 3 – Info Ticket-Ausdruck:',
            },
            WARNING: { sort: 5, name: 'Text 4 – Info Nachweis:' },
            OUTRO: { sort: 5, name: 'Text 5 – Abschluss:' },
        },
    },

    TicketETicket: {
        sort: 5,
        name: 'E-Mail-Vorlage: Bestätigung Smartphone-Ticket',
        description:
            'Wird bei Ticketbuchung mit der Option „Smartphone-Ticket“ als Bestätigung versandt.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            IMPORTANT: {
                sort: 3,
                name: 'Text 3 – Info Ticket-Aktivierung:',
            },
            HINT: { sort: 4, name: 'Text 4 – Info zur Nutzung:' },
            OUTRO: { sort: 5, name: 'Text 5 – Abschluss:' },
        },
    },

    TicketInternal: {
        sort: 6,
        name: 'E-Mail-Vorlage: Keycardproduktion & Versand durch die Bergbahn',
        description:
            'Wird bei Ticketbuchung mit der Option „interne Produktion“ als Bestätigung versandt. Diese Buchungsoption wird nur in Ausnahmefällen aktiviert, wir empfehlen vorab ein Gespräch mit starjack, auch wegen der benötigten Hard- und Software.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO1: { sort: 2, name: 'Text 2a – Einleitung:' },
            INTRO2: { sort: 3, name: 'Text 2b – Einleitung:' },
            INFO1: { sort: 4, name: 'Text 3 – Info Zusendung:' },
            INFO2: { sort: 5, name: 'Text 4 – Info Rückfragen:' },
            OUTRO: { sort: 6, name: 'Text 5 – Abschluss:' },
        },
    },

    TicketCancellation: {
        sort: 7,
        name: 'E-Mail-Vorlage: Rückgabe Ticket (Stornierung)',
        description:
            'Der Gast erhält bei der Rückgabe-Option den Ticketwert als Guthaben in sein Webshop-Konto, bei der nächsten Buchung wird das Guthaben automatisch zur Zahlung verwendet.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            HINT: { sort: 3, name: 'Text 3 – Info Rückbuchung:' },
            OUTRO: { sort: 4, name: 'Text 5 – Abschluss:' },
        },
    },

    KeycardProduced: {
        sort: 8,
        name: 'E-Mail-Vorlage: Bestätigung Keycard-Versand',
        description:
            'Diese E-Mail wird beim Versand der Keycard als Info an den Gast versendet.',
        variables: {
            TEXT1: {
                sort: 1,
                name: 'Text 1 – E-Mail-Betreff: (Ansicht Mustervorlage)',
            },
            TEXT2: {
                sort: 2,
                name: 'Text 2 – Anrede: (Ansicht Mustervorlage)',
            },
            TEXT3: {
                sort: 3,
                name: 'Text 3 – Einleitung: (Ansicht Mustervorlage)',
            },
            TEXT4: {
                sort: 4,
                name: 'Text 4 – Versandinfo: (Ansicht Mustervorlage)',
            },
            TEXT5: {
                sort: 5,
                name: 'Text 5 – Info Dauer der Zustellung / Funktion (Ansicht Mustervorlage)',
            },
            TEXT6: {
                sort: 6,
                name: 'Text 6 – Info Keycard im Webshop-Konto hinterlegt: (Ansicht Mustervorlage)',
            },
            OUTRO: {
                sort: 7,
                name: 'Text 6 – Abschluss (Ansicht Mustervorlage)',
            },
        },
    },

    Activation: {
        sort: 9,
        name: 'E-Mail-Vorlage: Registrierung / Aktivierung',
        description:
            'Diese E-Mail wird bei der Registrierung eines neuen Kunden versendet und enthält den Aktivierungslink für den Account.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            BODY: { sort: 3, name: 'Text 3 – Beschreibung:' },
            OUTRO: { sort: 4, name: 'Text 4 – Abschluss:' },
        },
    },

    Recovery: {
        sort: 10,
        name: 'E-Mail-Vorlage: Passwort vergessen',
        description:
            'Diese E-Mail wird versendet, wenn ein Kunde sein Passwort zurücksetzen möchte. Sie enthält den Link zum Zurücksetzen des Passworts.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            HINT: { sort: 3, name: 'Text 3 – Hinweis zur Gültigkeit:' },
            OUTRO: { sort: 4, name: 'Text 4 – Abschluss:' },
        },
    },

    EmailChangeRequest: {
        sort: 11,
        name: 'E-Mail-Vorlage: E-Mail-Änderung Anfrage',
        description:
            'Diese E-Mail wird an die neue E-Mail-Adresse versendet, wenn ein Kunde seine E-Mail-Adresse ändern möchte. Sie enthält den Bestätigungslink.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            OUTRO: { sort: 3, name: 'Text 3 – Abschluss:' },
        },
    },

    EmailChangeConfirmation: {
        sort: 12,
        name: 'E-Mail-Vorlage: E-Mail-Änderung Bestätigung',
        description:
            'Diese E-Mail wird versendet, nachdem ein Kunde seine neue E-Mail-Adresse erfolgreich bestätigt hat.',
        variables: {
            SUBJECT: { sort: 1, name: 'Text 1 – E-Mail-Betreff:' },
            INTRO: { sort: 2, name: 'Text 2 – Einleitung:' },
            INFO: { sort: 3, name: 'Text 3 – Info:' },
            OUTRO: { sort: 4, name: 'Text 4 – Abschluss:' },
        },
    },
};
